import React, { useState, useEffect } from 'react';
import { salesApi } from '../../api';
import { PageHeader, Table, Pagination, message, formatDate } from '../../components/common';

const DeveloperSales = () => {
  const [records, setRecords] = useState([]);
  const [loading, setLoading] = useState(true);
  const [pagination, setPagination] = useState({ page: 1, per_page: 10, total: 0 });
  const [filters, setFilters] = useState({ is_delivered: '', is_settled: '', keyword: '' });
  const [sort, setSort] = useState({ field: 'created_at', order: 'desc' });

  const fetchRecords = async () => {
    setLoading(true);
    try {
      const params = {
        page: pagination.page,
        per_page: pagination.per_page,
        ...filters,
        sort_by: sort.field,
        order: sort.order
      };
      Object.keys(params).forEach(k => !params[k] && delete params[k]);
      const res = await salesApi.getList(params);
      setRecords(res.data.items);
      setPagination(prev => ({ ...prev, total: res.data.total }));
    } catch (err) {
      message.error(err.message);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => { fetchRecords(); }, [pagination.page, pagination.per_page, sort]);

  const handleSearch = () => {
    setPagination(prev => ({ ...prev, page: 1 }));
    fetchRecords();
  };

  const handleSort = (field, order) => {
    setSort({ field, order });
  };

  const columns = [
    { key: 'id', title: 'ID', width: '60px', sorter: true },
    { key: 'customer_name', title: '客户名称', render: (v) => v || '-', sorter: true },
    { key: 'customer_email', title: '客户邮箱', sorter: true },
    { key: 'customer_phone', title: '手机号', render: (v) => v || '-' },
    { key: 'customer_gender', title: '性别', render: (v) => v === 'male' ? '男' : v === 'female' ? '女' : '-' },
    { key: 'customer_age', title: '年龄', render: (v) => v || '-' },
    { key: 'amount', title: '金额', render: (v) => `¥${v.toFixed(2)}`, sorter: true },
    { key: 'sales_name', title: '销售人员' },
    { key: 'google_account', title: '绑定账号', render: (v) => v ? v.email : '-' },
    { key: 'is_delivered', title: '发号状态', render: (v) => <span className={`tag ${v ? 'tag-success' : 'tag-default'}`}>{v ? '已发号' : '未发号'}</span>, sorter: true },
    { key: 'is_settled', title: '结算状态', render: (v) => <span className={`tag ${v ? 'tag-success' : 'tag-default'}`}>{v ? '已结算' : '待结算'}</span>, sorter: true },
    { key: 'created_at', title: '创建时间', render: (v) => formatDate(v), sorter: true },
  ];

  return (
    <div>
      <PageHeader title="关联销售记录" />

      <div className="search-bar">
        <div className="form-item">
          <input placeholder="搜索客户名称" value={filters.keyword} onChange={e => setFilters({ ...filters, keyword: e.target.value })} />
        </div>
        <div className="form-item">
          <select value={filters.is_delivered} onChange={e => setFilters({ ...filters, is_delivered: e.target.value })}>
            <option value="">全部发号状态</option>
            <option value="true">已发号</option>
            <option value="false">未发号</option>
          </select>
        </div>
        <div className="form-item">
          <select value={filters.is_settled} onChange={e => setFilters({ ...filters, is_settled: e.target.value })}>
            <option value="">全部结算状态</option>
            <option value="true">已结算</option>
            <option value="false">待结算</option>
          </select>
        </div>
        <button className="btn btn-primary" onClick={handleSearch}>搜索</button>
      </div>

      <Table
        columns={columns}
        data={records}
        loading={loading}
        sort={sort}
        onSort={handleSort}
      />
      <Pagination current={pagination.page} total={pagination.total} pageSize={pagination.per_page}
        onChange={(page) => setPagination(prev => ({ ...prev, page }))}
        onPageSizeChange={(size) => setPagination(prev => ({ ...prev, per_page: size, page: 1 }))} />
    </div>
  );
};

export default DeveloperSales;
